// extracted by mini-css-extract-plugin
export default {"labelValueColumn":"labelValueColumn_labelValueColumn__T4LJ2"};